import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
import { storeToRefs } from "pinia";
import Snackbar from '../atoms/Snackbar.vue';
import { useAcknowledgementStore } from '../../store';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Snackbars',
    setup: function (__props) {
        var acknowledgementStore = useAcknowledgementStore();
        var snackbars = storeToRefs(acknowledgementStore).snackbars;
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("aside", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(snackbars), function (snackbar, index) {
                    return (_openBlock(), _createBlock(Snackbar, {
                        key: snackbar.id,
                        bottomClass: "bottom-".concat(60 + 20 * index, "px"),
                        value: snackbar
                    }, null, 8, ["bottomClass", "value"]));
                }), 128))
            ]));
        };
    }
});
